import { userConstants } from "../_redux-constants";
import { userService } from "../../_services";
import { setStorageItem, getDataFromToken, history } from "../../_helpers";

function corporateLogin(accessToken) {
  function request() {
    return { type: userConstants.LOGIN_REQUEST };
  }

  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }

  return (dispatch) => {
    dispatch(request());
    return new Promise((resolve) => {
      setStorageItem("user", accessToken);

      const user = {
        roles: getDataFromToken(accessToken?.accessToken).roles,
        name: getDataFromToken(accessToken?.accessToken).name,
      };

      dispatch(success(user));
      resolve();
    });
  };
}

function login(username, password, from) {
  function request(user) {
    return { type: userConstants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: userConstants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: userConstants.LOGIN_FAILURE, error };
  }

  return (dispatch) => {
    dispatch(request({ username }));

    userService.login(username, password).then(
      (loginData) => {
        const user = {
          roles: getDataFromToken(loginData?.accessToken).roles,
          name: getDataFromToken(loginData?.accessToken).name,
        };
        dispatch(success(user));
        history.replace(from);
      },
      (error) => {
        dispatch(failure(error?.toString()));
      }
    );
  };
}

function logout() {
  userService.logout();
  return { type: userConstants.LOGOUT };
}

export const userActions = {
  login,
  logout,
  corporateLogin,
};
